class KokoSetGallery {
  constructor(root) {
    this.root = root;
    this.track = root.querySelector('[data-gallery-track]');
    this.slides = [...root.querySelectorAll('[data-gallery-slide]')];
    this.buttons = [...root.querySelectorAll('[data-gallery-button]')];
    if (!this.track || !this.slides.length) return;
    this.buttons.forEach((button) => button.addEventListener('click', () => this.go(Number(button.dataset.galleryButton))));
    this.track.addEventListener('scroll', () => this.queueUpdate(), { passive: true });
    this.update(0);
  }
  go(index) { this.track.scrollTo({ left: this.track.clientWidth * index, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' }); }
  queueUpdate() { cancelAnimationFrame(this.frame); this.frame = requestAnimationFrame(() => this.update(Math.round(this.track.scrollLeft / Math.max(this.track.clientWidth, 1)))); }
  update(index) {
    const safe = Math.max(0, Math.min(index, this.slides.length - 1));
    this.root.style.setProperty('--set-gallery-index', safe);
    this.buttons.forEach((button, buttonIndex) => {
      button.classList.toggle('is-active', buttonIndex === safe);
      if (buttonIndex === safe) button.setAttribute('aria-current', 'true'); else button.removeAttribute('aria-current');
    });
  }
}
document.querySelectorAll('[data-koko-set-gallery]').forEach((root) => new KokoSetGallery(root));
